export class UtilsHelper {
  static nameSensor(type: number | string): { name: string; icon: string } {
    switch (type) {
      case 1:  return { name: 'AT32 (Humedad suelo)', icon: 'layers' };
      case 2:  return { name: 'TD100 (Tensiómetro)', icon: 'speed' };
      case 3:  return { name: 'MET3 (Sensor ambiental)', icon: 'thermostat' };
      case 4:  return { name: 'H2 (Sensor de humectación de hoja)', icon: 'energy_savings_leaf' };
      case 5:  return { name: 'Water potential', icon: 'speed' };
      case 6:  return { name: 'Pressure', icon: 'speed' };
      case 7:  return { name: 'RG22 (Pluviómetro)', icon: 'cloud_queue' };
      case 8:  return { name: 'CP9 (Contador de pulsos)', icon: 'gas_meter' };
      case 9:  return { name: 'NA1 (Sensor de nivel sumergible)', icon: 'water' };
      case 10: return { name: 'ES2 (Conductividad agua)', icon: 'electric_meter' };
      case 11: return { name: 'NPK (Macronutrientes del suelo)', icon: 'local_florist' };
      case 12: return { name: 'PH', icon: 'local_florist' };
      case 13: return { name: 'ATMOS22 (Velocidad viento)', icon: 'layers' };
      case 14: return { name: 'TEROS21 (Tensiómetro)', icon: 'speed' };
      case 15: return { name: 'BGTPH1', icon: 'layers' };
      case 16: return { name: 'ACCLIMA TDR315 (Humedad suelo)', icon: 'layers' };
      case 17: return { name: 'CS320', icon: 'local_florist' };
      case 18: return { name: 'S2441SS', icon: 'local_florist' };
      case 19: return { name: 'S2422SS', icon: 'local_florist' };
      case 20: return { name: 'GERBIL XP02 (Humedad suelo)', icon: 'layers' };
      case 21: return { name: 'GERBIL XP03 (Humedad suelo)', icon: 'layers' };
      case 22: return { name: 'GERBIL XP04 (Humedad suelo)', icon: 'layers' };
      case 23: return { name: 'GERBIL XP06 (Humedad suelo)', icon: 'layers' };
      case 24: return { name: 'GERBIL XP08 (Humedad suelo)', icon: 'layers' };
      case 25: return { name: 'IG31 (Humedad suelo)', icon: 'layers' };
      case 26: return { name: 'MET3 (Sensor ambiental)', icon: 'thermostat' };
      case 27: return { name: 'IG90 PLUVIÓMETRO / CONTADOR DE PULSOS', icon: 'cloud_queue' };
      case 28: return { name: 'TEROS12 (Humedad suelo)', icon: 'layers' };
      case 29: return { name: 'ES2 (Conductividad agua)', icon: 'local_florist' };
      case 30: return { name: 'AT32 (Humedad suelo)', icon: 'layers' };
      case 31: return { name: 'HYDROS21 (Nivel agua)', icon: 'local_florist' };
      case 32: return { name: 'SP522SS', icon: 'local_florist' };
      case 33: return { name: 'BGTTBQ', icon: 'local_florist' };
      case 34: return { name: 'CO2SENSOR', icon: 'local_florist' };
      case 35: return { name: 'BGTWECK', icon: 'local_florist' };
      case 36: return { name: 'BGTWPHK', icon: 'local_florist' };
      case 37: return { name: 'TD50', icon: 'speed' };
      case 38: return { name: 'TD100 (Tensiómetro)', icon: 'speed' };
      case 39: return { name: 'TD420', icon: 'local_florist' };
      case 40: return { name: 'CWTSWDC360A_05', icon: 'local_florist' };
      case 41: return { name: 'CWTSWDC360A_010', icon: 'local_florist' };
      case 42: return { name: 'CWTSWDC360A_420', icon: 'local_florist' };
      case 43: return { name: 'CP9 (Contador de pulsos)', icon: 'gas_meter' };
      case 44: return { name: 'LWS10 (Humectación de hoja)', icon: 'layers' };
      case 45: return { name: 'PIRANÓMETRO', icon: 'layers' };
      case 46: return { name: 'VELETA 010 (Dirección del viento)', icon: 'layers' };
      case 47: return { name: 'ANEMÓMETRO 010 (Velocidad del viento)', icon: 'layers' };
      case 48: return { name: 'NA1 (Sensor de nivel sumergible)', icon: 'water' };
      case 49: return { name: 'GENERICA 02', icon: 'layers' };
      case 50: return { name: 'GENERICA 5V', icon: 'layers' };
      case 51: return { name: 'GENERICA 10V', icon: 'layers' };
      case 52: return { name: 'GENERICA 4-20mA', icon: 'layers' };
      case 53: return { name: 'ATMOS41 (Estación meteorológica)', icon: 'layers' };
      case 54: return { name: 'PUERTO VACÍO', icon: '' };
      case 55: return { name: 'PUERTO VACÍO', icon: '' };
      case 56: return { name: 'PUERTO VACÍO', icon: '' };
      case 57: return { name: 'PUERTO VACÍO', icon: '' };
      case 58: return { name: 'PUERTO VACÍO', icon: '' };


      default: return { name: `Sensor ${type}`, icon: 'help_outline' };
    }



  }


  private static readonly SENSOR_NAME_TO_TYPE: Record<string, number> = {
    NONE: 0, GROUND: 1, TENSIOMETER: 2, AMBIENT: 3, HUMIDIFICATION: 4,
    WATERPOTENTIAL: 5, PREASSURE: 6, PLUVIOMETER: 7, PULSE: 8, LEVEL: 9,
    WATERCONDUCTIVITY: 10, NPK: 11, PH: 12, ATMOS22: 13, TEROS21_GEN2: 14,
    BGTPH1: 15, ACCLIMA_TDR315H: 16, CS320: 17, S2441SS: 18, S2422SS: 19,
    GERBIL_XP02: 20, GERBIL_XP03: 21, GERBIL_XP04: 22, GERBIL_XP06: 23, GERBIL_XP08: 24,
    IG31: 25, IG71: 26, IG90_PLUVIOMETER: 27, TEROS12: 28, ES2: 29, MEC10: 30,
    HYDROS21: 31, SP522SS: 32, BGTTBQ: 33, CO2SENSOR: 34, BGTWECK: 35, BGTWPHK: 36,
    WNK80MA_05: 37, WNK80MA_010: 38, WNK80MA_420: 39, CWTSWDC360A_05: 40,
    CWTSWDC360A_010: 41, CWTSWDC360A_420: 42, IG90_PULSE: 43, LWS10: 44,
    PYR20AABXXX: 45, CHINAWINDDIR_010: 46, CHINAWINDSPEED_010: 47,
    WNK8010TT20S1C130D4: 48, GENERICA_02: 49, GENERICA_05: 50, GENERICA_010: 51,
    GENERICA_420: 52, ATMOS41: 53,
  };

  static sensorTypeToNumber(typeName: string): number {
    return UtilsHelper.SENSOR_NAME_TO_TYPE[typeName] ?? 0;
  }

  static nameModule(type: number | string): string {
    switch (type) {
      case '0': return 'SDI12';
      case '1': return 'DDI';
      case '2': return 'RS232';
      case '3': return 'RS485';
      case '4': return 'ANALÓGICO';

      default:
        return `Module ${type}`;
    }
  }


  static readonly sensorsByModule: Record<number, number[]> = {
    0: [ // SDI12
      13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 28, 29, 53, 54
    ],
    1: [ // DDI
      25, 26, 27, 28, 14, 29, 30, 31, 44, 55
    ],
    2: [ // RS232
      32, 33, 56
    ],
    3: [ // RS485
      34, 35, 36, 30, 44, 57
    ],
    4: [ // ANALOGICO
      37, 38, 39, 40, 41, 42, 45, 46, 47, 48, 49, 50, 51, 52, 58
    ],
  };



  static getAvailableSensorsByModule(module: number | string): Array<{ id: number; name: string; icon: string }> {
    const m = Number(module);
    const ids = this.sensorsByModule[m] ?? [];
    return ids.map(id => ({ id, ...this.nameSensor(id) }));
  }
}
